import { getVideos } from "./videosAPI";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
  videos: [],
  totalVideos: 0,
  isLoading: false,
  isError: false,
  error: "",
};

// async thunk
export const fetchVideos = createAsyncThunk(
  "videos/fetchVideos",
  async ({ tags, search, page, limit, author }) => {
    const videosData = await getVideos(tags, search, page, limit, author);
    return videosData;
  }
);

const videoSlice = createSlice({
  name: "videos",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchVideos.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
        state.totalVideos = 0;
      })
      .addCase(fetchVideos.fulfilled, (state, action) => {
        state.isLoading = false;
        state.videos = action.payload?.videos;
        state.totalVideos = action.payload?.totalVideos;
      })
      .addCase(fetchVideos.rejected, (state, action) => {
        state.isLoading = false;
        state.videos = [];
        state.isError = true;
        state.error = action.error?.message;
        state.totalVideos = 0;
      });
  },
});

export default videoSlice.reducer;
